import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../constants/app-constants';
import { AuthService } from './auth.service';
import { DataService } from './data.service';
import { TokenService } from './token.service';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class AuthGuardService  {
    constructor(public auth: AuthService, public router: Router, public userCacheService: UserCacheService, private logoutService: TokenService, private dataService: DataService) { }
    canActivate(): boolean {
        if (!this.auth.isAuthenticated()) {
            this.logout();
            return false;
        }
        return true;
    }

    async logout() {
        try {
            this.logoutService.logout().subscribe(() => {
                this.clearAllData();
            }, (_err: any) => {
                this.clearAllData();
            });
        } catch (error) {
            this.clearAllData();
        }
    }

    clearAllData() {
        const participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
        const storyId = this.userCacheService.getUserData(AppConstants.STORY_ID);
        this.userCacheService.eraseAllUserData();
        this.dataService.userLoggedIn(false);
        if(participantId){
            // this.router.navigate([participantId]);
            window.location.href = `/logout`;
        }
        if(storyId){
            // this.router.navigate(['school/' + storyId]);
            window.location.href = `/logout`;
        }
    }
}